export default __webpack_public_path__ + "static/media/aj5.12dd93b4.png";